module.exports = __webpack_public_path__ + "img/time_line_circular_connect_head.92fe3c3e.svg";